// extracted by mini-css-extract-plugin
export var noSpinners = "_oq-6";
export var percentageInput = "_oq-7";
export var variantColor1 = "_oq-0";
export var variantColor2 = "_oq-1";
export var variantColor3 = "_oq-2";
export var variantColor4 = "_oq-3";
export var variantColor5 = "_oq-4";
export var variantColor6 = "_oq-5";